import { i18n } from '@/i18n'
import configHelper from '@/config/ConfigHelper'

function GenerateAccionesFlujoAprobacion () {
  return [
    {
      id: 303,
      Nombre: i18n.t('tipos.accion.approve'),
      NombreEdit: i18n.t('tipos.accion.save_and_approve'),
      Modulo: [6],
      idDecision: 1,
    },
    {
      id: 301,
      Nombre: i18n.t('tipos.accion.reject_received'),
      NombreEdit: i18n.t('tipos.accion.save_and_reject'),
      Modulo: [6],
      idDecision: 2,
    },
    {
      id: 302,
      Nombre: i18n.t('tipos.accion.reassign_workflow'),
      NombreEdit: i18n.t('tipos.accion.save_and_reassign'),
      Modulo: [6],
      idDecision: 3,
    }
  ]
}

function ACCIONES_FLUJO_APROBACION (state) {
  return configHelper.getConfig(state, 'ACCIONES_FLUJO_APROBACION', GenerateAccionesFlujoAprobacion)
}

export { ACCIONES_FLUJO_APROBACION }
